<template>
   <div>
      <v-container>
         <v-row no-gutters>
            <v-col cols="12">
               <v-toolbar
                  dense
                  :color="this.$globalstore.secondary_titleclass"
                  bottom
               >
                  <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                     Message: {{ defaultmessagename }}
                  </v-toolbar-title>
                  <v-icon color="white" v-else>mdi-email-edit-outline</v-icon>
                  <v-spacer></v-spacer>
                  <v-btn
                     color="indigo"
                     class="white ma-2"
                     outlined
                     @click="saveMessage"
                  >
                     Save
                  </v-btn>
                  <v-btn
                     color="indigo"
                     class="white ma-2"
                     outlined
                     @click="goBack()"
                  >
                     Back
                  </v-btn>
               </v-toolbar>
            </v-col>
         </v-row>

         <v-row no-gutters class="mt-4">
            <v-col cols="12" md="12">
               <v-card flat>
                  <v-textarea
                     auto-grow
                     rows="2"
                     readonly
                     outlined
                     label="Remarks"
                     v-model="remarks"
                  ></v-textarea>
               </v-card>
            </v-col>
         </v-row>
         <v-row>
            <v-col cols="12" md="12">
               <v-card outlined class="px-2">
                  <v-text-field
                     ref="subject"
                     v-model="msgSubject"
                     label="Subject"
                     @focus="subjectSetFocus"
                  ></v-text-field>
               </v-card>
               <v-row no-gutters>
                  <v-col cols="12" md="9">
                     <v-card
                        dense
                        flat
                        outlined
                        v-if="!editorreadonly"
                        class="mt-2"
                     >
                        <v-row no-gutters>
                           <v-col cols="12" md="12">
                              <v-card v-if="editor">
                                 <!-- Toggle bold -->
                                 <button
                                    @click="toggleBold"
                                    :class="[
                                       { 'is-active': editor.isActive('bold') },
                                       'pa-0',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-bold</v-icon>
                                 </button>
                                 <!-- Toggle italic -->
                                 <button
                                    @click="toggleItalic"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'italic'
                                          ),
                                       },
                                       'pa-0',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-italic</v-icon>
                                 </button>
                                 <!-- Set paragraph -->
                                 <button
                                    @click="setParagraph"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'paragraph'
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-paragraph</v-icon>
                                 </button>
                                 <!-- Toggle heading 1 -->
                                 <button
                                    @click="toggleHeading(1)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'heading',
                                             {
                                                level: 1,
                                             }
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-1</v-icon>
                                 </button>
                                 <!-- Toggle heading 2 -->
                                 <button
                                    @click="toggleHeading(2)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'heading',
                                             {
                                                level: 2,
                                             }
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-2</v-icon>
                                 </button>
                                 <!-- Toggle heading 3 -->
                                 <button
                                    @click="toggleHeading(3)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'heading',
                                             {
                                                level: 3,
                                             }
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-3</v-icon>
                                 </button>
                                 <!-- Toggle heading 4 -->
                                 <button
                                    @click="toggleHeading(4)"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'heading',
                                             {
                                                level: 4,
                                             }
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-header-4</v-icon>
                                 </button>
                                 <!-- Bullet list -->
                                 <button
                                    @click="toggleBulletList"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'bulletList'
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small
                                       >mdi-format-list-bulleted</v-icon
                                    >
                                 </button>
                                 <!-- Toggle ordered list -->
                                 <button
                                    @click="toggleOrderedList"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'orderedList'
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small
                                       >mdi-format-list-numbered</v-icon
                                    >
                                 </button>
                                 <!-- Set text alignment left -->
                                 <button
                                    @click="setTextAlign('left')"
                                    :class="[
                                       {
                                          'is-active': editor.isActive({
                                             textAlign: 'left',
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-align-left</v-icon>
                                 </button>
                                 <!-- Set text alignment center -->
                                 <button
                                    @click="setTextAlignment('center')"
                                    :class="[
                                       {
                                          'is-active': editor.isActive({
                                             textAlign: 'center',
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small
                                       >mdi-format-align-center</v-icon
                                    >
                                 </button>
                                 <!-- Set text alignment right -->
                                 <button
                                    @click="
                                       editor
                                          .chain()
                                          .focus()
                                          .setTextAlign('right')
                                          .run()
                                    "
                                    :class="[
                                       {
                                          'is-active': editor.isActive({
                                             textAlign: 'right',
                                          }),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small
                                       >mdi-format-align-right</v-icon
                                    >
                                 </button>
                                 <!-- Toggle underline -->
                                 <button
                                    @click="toggleUnderLine"
                                    :class="[
                                       {
                                          'is-active': editor.isActive(
                                             'underline'
                                          ),
                                       },
                                       'mr-1',
                                       'menubtn',
                                    ]"
                                 >
                                    <v-icon small>mdi-format-underline</v-icon>
                                 </button>
                                 <!-- Show table menu -->
                                 <!-- <button @click="showTableMenu" class="mr-1 menubtn">
                           <v-icon small>mdi-table-large</v-icon>
                        </button> -->

                                 <!-- Undo last action -->
                                 <button
                                    @click="undoLastAction"
                                    class="mr-1 menubtn"
                                 >
                                    <v-icon small>mdi-undo</v-icon>
                                 </button>
                                 <!-- Redo last action -->
                                 <button
                                    @click="redoLastAction"
                                    class="mr-1 menubtn"
                                 >
                                    <v-icon small>mdi-redo</v-icon>
                                 </button>

                                 <!-- Text color selection -->
                                 <input
                                    class="inputcolor"
                                    type="color"
                                    @input="
                                       editor
                                          .chain()
                                          .focus()
                                          .setColor($event.target.value)
                                          .run()
                                    "
                                    :value="
                                       editor.getAttributes('textStyle').color
                                    "
                                 />
                              </v-card>
                           </v-col>
                        </v-row>
                     </v-card>
                     <v-card
                        height="40vh"
                        class="mt-2 px-2 pt-2 overflow-y-auto"
                     >
                        <editor-content :editor="editor" />
                     </v-card>
                  </v-col>

                  <v-col
                     cols="12"
                     md="3"
                     :order="$vuetify.breakpoint.mdAndUp ? '' : 'first'"
                  >
                     <v-card class="ml-2 pt-2 over-flow-y-auto">
                        <v-row no-gutters>
                           <v-col cols="12" md="12">
                              <v-expansion-panels v-model="panelExpanded">
                                 <!-- Student Panel -->
                                 <v-expansion-panel class="px-0">
                                    <v-expansion-panel-header>
                                       Student
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="px-0">
                                       <v-card
                                          flat
                                          :height="
                                             $vuetify.breakpoint.mdAndUp
                                                ? '10vh'
                                                : '10vh'
                                          "
                                          class="overflow-y-auto"
                                       >
                                          <table width="100%">
                                             <tr
                                                v-for="txt in studentmergetext"
                                                :key="txt.id"
                                                class="mergerow pa-1"
                                             >
                                                <td class="pa-1" width="90%">
                                                   {{ txt.text }}
                                                </td>
                                                <td
                                                   class="pa-1"
                                                   width="10%"
                                                   align="center"
                                                >
                                                   <v-icon
                                                      @click="
                                                         insertMergeLabel(
                                                            txt.mergelabel
                                                         )
                                                      "
                                                      >mdi-pencil</v-icon
                                                   >
                                                </td>
                                             </tr>
                                          </table>
                                       </v-card>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                                 <!-- Parent Panel -->
                                 <v-expansion-panel class="px-0">
                                    <v-expansion-panel-header>
                                       Parent
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="px-0">
                                       <v-card
                                          flat
                                          :height="
                                             $vuetify.breakpoint.mdAndUp
                                                ? '10vh'
                                                : '10vh'
                                          "
                                          class="overflow-y-auto"
                                       >
                                          <table width="100%">
                                             <tr
                                                v-for="txt in parentmergetext"
                                                :key="txt.id"
                                                class="mergerow pa-1"
                                             >
                                                <td class="pa-1" width="90%">
                                                   {{ txt.text }}
                                                </td>
                                                <td
                                                   class="pa-1"
                                                   width="10%"
                                                   align="center"
                                                >
                                                   <v-icon
                                                      @click="
                                                         insertMergeLabel(
                                                            txt.mergelabel
                                                         )
                                                      "
                                                      >mdi-pencil</v-icon
                                                   >
                                                </td>
                                             </tr>
                                          </table>
                                       </v-card>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                                 <!-- CCA Group -->
                                 <v-expansion-panel class="px-0">
                                    <v-expansion-panel-header>
                                       CCA Group
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="px-0">
                                       <v-card
                                          flat
                                          :height="
                                             $vuetify.breakpoint.mdAndUp
                                                ? '20vh'
                                                : '15vh'
                                          "
                                          class="overflow-y-auto"
                                       >
                                          <table width="100%">
                                             <tr
                                                v-for="txt in ccagroupmergetext"
                                                :key="txt.id"
                                                class="mergerow pa-1"
                                             >
                                                <td class="pa-1" width="90%">
                                                   {{ txt.text }}
                                                </td>
                                                <td
                                                   class="pa-1"
                                                   width="10%"
                                                   align="center"
                                                >
                                                   <v-icon
                                                      @click="
                                                         insertMergeLabel(
                                                            txt.mergelabel
                                                         )
                                                      "
                                                      >mdi-pencil</v-icon
                                                   >
                                                </td>
                                             </tr>
                                          </table>
                                       </v-card>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                                 <!-- Staff -->
                                 <v-expansion-panel class="px-0">
                                    <v-expansion-panel-header>
                                       Staff
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="px-0">
                                       <v-card
                                          flat
                                          :height="
                                             $vuetify.breakpoint.mdAndUp
                                                ? '5vh'
                                                : '5vh'
                                          "
                                          class="overflow-y-auto"
                                       >
                                          <table width="100%">
                                             <tr
                                                v-for="txt in staffmergetext"
                                                :key="txt.id"
                                                class="mergerow pa-1"
                                             >
                                                <td class="pa-1" width="90%">
                                                   {{ txt.text }}
                                                </td>
                                                <td
                                                   class="pa-1"
                                                   width="10%"
                                                   align="center"
                                                >
                                                   <v-icon
                                                      @click="
                                                         insertMergeLabel(
                                                            txt.mergelabel
                                                         )
                                                      "
                                                      >mdi-pencil</v-icon
                                                   >
                                                </td>
                                             </tr>
                                          </table>
                                       </v-card>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                                 <!-- Vendor -->
                                 <v-expansion-panel class="px-0">
                                    <v-expansion-panel-header>
                                       Vendor
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="px-0">
                                       <v-card
                                          flat
                                          :height="
                                             $vuetify.breakpoint.mdAndUp
                                                ? '5vh'
                                                : '5vh'
                                          "
                                          class="overflow-y-auto"
                                       >
                                          <table width="100%">
                                             <tr
                                                v-for="txt in vendormergetext"
                                                :key="txt.id"
                                                class="mergerow pa-1"
                                             >
                                                <td class="pa-1" width="90%">
                                                   {{ txt.text }}
                                                </td>
                                                <td
                                                   class="pa-1"
                                                   width="10%"
                                                   align="center"
                                                >
                                                   <v-icon
                                                      @click="
                                                         insertMergeLabel(
                                                            txt.mergelabel
                                                         )
                                                      "
                                                      >mdi-pencil</v-icon
                                                   >
                                                </td>
                                             </tr>
                                          </table>
                                       </v-card>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                                 <!-- Proposal Panel -->
                                 <v-expansion-panel class="px-0">
                                    <v-expansion-panel-header>
                                       Proposal
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="px-0">
                                       <v-card
                                          flat
                                          :height="
                                             $vuetify.breakpoint.mdAndUp
                                                ? '10vh'
                                                : '10vh'
                                          "
                                          class="overflow-y-auto"
                                       >
                                          <table width="100%">
                                             <tr
                                                v-for="txt in proposalmergetext"
                                                :key="txt.id"
                                                class="mergerow pa-1"
                                             >
                                                <td class="pa-1" width="90%">
                                                   {{ txt.text }}
                                                </td>
                                                <td
                                                   class="pa-1"
                                                   width="10%"
                                                   align="center"
                                                >
                                                   <v-icon
                                                      @click="
                                                         insertMergeLabel(
                                                            txt.mergelabel
                                                         )
                                                      "
                                                      >mdi-pencil</v-icon
                                                   >
                                                </td>
                                             </tr>
                                          </table>
                                       </v-card>
                                    </v-expansion-panel-content>
                                 </v-expansion-panel>
                              </v-expansion-panels>
                           </v-col>
                        </v-row>
                     </v-card>
                  </v-col>
               </v-row>
            </v-col>
         </v-row>
      </v-container>
      <show-toast ref="toast"></show-toast>
   </div>
</template>

<script>
   import { RecipientConst } from "@/common/recipientconstant.js";
   import { Editor, EditorContent } from "@tiptap/vue-2";
   import StarterKit from "@tiptap/starter-kit";
   import TextStyle from "@tiptap/extension-text-style";
   import { Color } from "@tiptap/extension-color";
   import TextAlign from "@tiptap/extension-text-align";
   import Table from "@tiptap/extension-table";
   import TableRow from "@tiptap/extension-table-row";
   import TableCell from "@tiptap/extension-table-cell";
   import TableHeader from "@tiptap/extension-table-header";
   import UnderLine from "@tiptap/extension-underline";
   import {
      StudentMergeText,
      ParentMergeText,
      StaffMergeText,
      CCAGroupMergeText,
      VendorMergeText,
      ProposalMergeText,
   } from "@/common/mergetext.js";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         EditorContent,
         ShowToast,
      },

      data() {
         return {
            recipientmenu: RecipientConst.RECIPIENT_CATEGORY,
            rcpttype: RecipientConst.RECIPIENT_TYPE,
            recipientdata: [],
            recipientcategory: 0,
            selectedrecipient: [],
            panelExpanded: "",
            msgSubject: "",
            msgHTMLBody: "",
            msgJSONBody: "",
            remarks: "",
            editor: null,
            editorreadonly: this.readonly || false,
            studentmergetext: StudentMergeText,
            parentmergetext: ParentMergeText,
            staffmergetext: StaffMergeText,
            ccagroupmergetext: CCAGroupMergeText,
            vendormergetext: VendorMergeText,
            proposalmergetext: ProposalMergeText,
            defaultmessagename: "",
            editmessage: null,
            subjectHasFocus: false,
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         subjectSetFocus() {
            this.subjectHasFocus = true;
         },

         messagekeyname() {
            return this.editmessage.messagename;
         },

         toggleBold() {
            this.editor
               .chain()
               .focus()
               .toggleBold()
               .run();
         },

         toggleItalic() {
            this.editor
               .chain()
               .focus()
               .toggleItalic()
               .run();
         },

         setParagraph() {
            this.editor
               .chain()
               .focus()
               .setParagraph()
               .run();
         },

         toggleHeading(headinglevel) {
            this.editor
               .chain()
               .focus()
               .toggleHeading({ level: headinglevel })
               .run();
         },

         toggleBulletList() {
            this.editor
               .chain()
               .focus()
               .toggleBulletList()
               .run();
         },

         toggleOrderedList() {
            this.editor
               .chain()
               .focus()
               .toggleOrderedList()
               .run();
         },

         setTextAlignment(position) {
            this.editor
               .chain()
               .focus()
               .setTextAlign(position)
               .run();
         },

         toggleUnderLine() {
            this.editor
               .chain()
               .focus()
               .toggleUnderline()
               .run();
         },

         insertMergeLabel(label) {
            if (this.subjectHasFocus) {
               this.subjectHasFocus = false;
               const subj = this.$refs.subject.$refs.input;
               const value = subj.value;
               const len = value.length;
               let pos = subj.selectionStart;

               if (pos === undefined) pos = 0;

               const before = value.substr(0, pos);
               const after = value.substr(pos, len);

               this.msgSubject = before + label + after;

               this.$nextTick().then(() => {
                  subj.selectionStart = pos + label.length;
               });
            } else {
               this.editor.commands.insertContent(label);
            }
         },

         showTableMenu() {
            // this.editor
            //    .chain()
            //    .focus()
            //    .insertTable({
            //       rows: 3,
            //       cols: 3,
            //       withHeaderRow: true,
            //    })
            //    .run();
            // this.editor.commands.insertContent(
            //    "<table><tr><td>Date:</td><td>2021-09-30</td></tr></table>"
            // );
         },

         undoLastAction() {
            this.editor
               .chain()
               .focus()
               .undo()
               .run();
         },

         redoLastAction() {
            this.editor
               .chain()
               .focus()
               .redo()
               .run();
         },

         saveMessage() {
            if (!this.msgSubject) {
               this.ShowMessage({
                  title: "Error",
                  message: "Please enter a subject for this message.",
                  color: "red",
               });
               return;
            }

            if (!this.msgHTMLBody) {
               this.msgHTMLBody = this.editor.getHTML();
               if (!this.msgHTMLBody || this.msgHTMLBody == "<p></p>") {
                  this.ShowMessage({
                     title: "Error",
                     message: "Message has no body.",
                     color: "red",
                  });
                  return;
               }
            }

            if (this.msgSubject && this.msgHTMLBody) {
               this.doSaveMessage();
            }
         },

         async doSaveMessage() {
            await this.$http({
               url: "/common/savedefaultmessage.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  messagename: this.editmessage.messagename,
                  dept: 1, // CCA. Change this for billing
                  subject: this.msgSubject,
                  messagebody: this.msgHTMLBody,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: "Message saved",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         resetMessage() {
            this.editor.commands.setContent("");
            this.recipientdata = [];
            this.msgSubject = "";
            this.msgHTMLBody = "";
         },
      },

      mounted() {
         this.editor = new Editor({
            onUpdate: () => {
               this.msgHTMLBody = this.editor.getHTML();
               this.subjectHasFocus = false;
            },
            extensions: [
               StarterKit,
               TextStyle,
               Color,
               TextAlign.configure({
                  types: ["heading", "paragraph"],
               }),
               Table.configure({
                  resizable: true,
               }),
               TableRow,
               TableCell,
               TableHeader,
               UnderLine,
            ],
            content: "",
         });
         if (this.$route.params.message) {
            this.editmessage = this.$route.params.message;
            this.defaultmessagename = this.editmessage.messagename;
            this.msgSubject = this.editmessage.messagesubject;
            this.remarks = this.editmessage.remarks;

            this.editor.commands.setContent(this.editmessage.messagetext);
            this.editor
               .chain()
               .focus()
               .run();
         }
      },

      beforeUnMount() {
         this.editor.destroy();
      },
   };
</script>

<style>
   .ProseMirror > * + * {
      margin-top: 0.2em;
   }
   .ProseMirror ul,
   .ProseMirror ol {
      padding: 0 1.2rem;
   }
   .ProseMirror li {
      margin-left: 1em;
      margin-bottom: -0.8em;
   }
   .ProseMirror h1,
   .ProseMirror h2,
   .ProseMirror h3,
   .ProseMirror h4,
   .ProseMirror h5,
   .ProseMirror h6 {
      line-height: 1.1;
   }
   .ProseMirror code {
      background-color: rgba(97, 97, 97, 0.1);
      color: #616161;
   }
   .ProseMirror pre {
      background: #0d0d0d;
      color: #fff;
      font-family: "JetBrainsMono", monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;
   }
   .ProseMirror pre code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
   }
   .ProseMirror img {
      max-width: 100%;
      height: auto;
   }
   .ProseMirror blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(13, 13, 13, 0.1);
   }
   .ProseMirror hr {
      border: none;
      border-top: 2px solid rgba(13, 13, 13, 0.1);
      margin: 2rem 0;
   }
   .ProseMirror-focused:focus {
      outline: none;
   }
   .ProseMirror p {
      line-height: 1.1em;
   }

   button.is-active {
      background: #9b9999;
   }
   .menubtn {
      height: 1.5em;
      width: 1.5em;
      border: 1px solid lightgrey;
   }

   .menubtn:hover {
      background: #ffcdd2 !important;
   }

   .inputcolor {
      width: 1.75rem;
      margin: 0.1rem;
      box-sizing: border-box;
      padding: 1px 2px;
      border: 1px solid darkgray;
   }

   .mergerow:hover {
      background-color: #ffcdd2;
   }

   .ProseMirror table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      margin: 0;
      overflow: hidden;
   }
   .ProseMirror table td,
   .ProseMirror table th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;
   }
   .ProseMirror table td > *,
   .ProseMirror table th > * {
      margin-bottom: 0;
   }
   .ProseMirror table th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
   }
   .ProseMirror table .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
   }
   .ProseMirror table .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
   }
   .tableWrapper {
      overflow-x: auto;
   }
   .resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
   }

   .rcpmenu:hover {
      background: #ffcdd2 !important;
   }
</style>
